class UIOverlay {
    options;
    el;
    closeEl = null;
    constructor(options) {
        this.options = options;
    }
    getContainerId() {
        return `${this.options.containerId}`;
    }
    getContentId() {
        return `${this.options.contentId}`;
    }
    isOver() {
        return (typeof this.options.over !== 'boolean') || this.options.over;
    }
    isUnder() {
        return (typeof this.options.over === 'boolean') && !this.options.over;
    }
    moveUnder() {
        this.options.over = false;
        this.updateLayer();
    }
    moveOver() {
        this.options.over = true;
        this.updateLayer();
    }
    updateLayer() {
        if (!this.el) {
            return;
        }
        if (this.isUnder() && typeof this.options.underlayer === 'number') {
            this.el.style.zIndex = `${100 * this.options.underlayer}`;
        }
        else {
            this.el.style.zIndex = `${100 * this.options.layer}`;
        }
    }
    render(size = 100, classes = []) {
        if (this.isCloseable()) {
            this.fixBodyScroll();
        }
        else {
            this.initMoveOverTrigger();
        }
        this.el = document.createElement('div');
        this.el.classList.add(this.getContainerId());
        this.updateLayer();
        this.el.style.width = `${size}%`;
        this.el.style.height = `${size}%`;
        let offset = (100 - size) / 2;
        this.el.style.top = `${offset}%`;
        this.el.style.left = `${offset}%`;
        this.el.innerHTML = `<a href="#" class="close"></a><div id="${this.getContentId()}"></div>`;
        this.el.classList.add('overlay');
        classes.forEach((className) => {
            this.el && this.el.classList.add(className);
        });
        this.setDataToElement();
        if (this.isCloseable()) {
            document.body.appendChild(this.el);
        }
        else {
            this.appendToParentContainer();
        }
        this.closeEl = this.el.querySelector('a.close');
        if (this.closeEl) {
            this.closeEl.addEventListener('click', e => this.closeClick(e));
        }
    }
    setDataToElement() {
        Object.keys(this.options.data).forEach((key) => {
            this.el && (this.el.dataset[key] = this.options.data[key]);
        });
    }
    closeClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.close();
        return false;
    }
    close() {
        if (this.isCloseable()) {
            this.removeElement();
        }
        else {
            this.moveUnder();
        }
    }
    removeElement() {
        this.freeBodyScroll();
        if (this.el && this.el.parentNode) {
            this.el.parentNode.removeChild(this.el);
        }
    }
    isCloseable() {
        return !this.options.startUnder;
    }
    fixBodyScroll() {
        document.body.style.height = window.innerHeight.toString() + 'px';
    }
    freeBodyScroll() {
        document.body.style.height = 'auto';
    }
    initMoveOverTrigger() {
        this.options.parentEl && this.options.parentEl.addEventListener('click', (e) => { e.preventDefault(); this.moveOver(); });
    }
    appendToParentContainer() {
        if (this.el && this.options.parentEl) {
            if (this.options.parentEl.style) {
                this.options.parentEl.style.backgroundColor = 'transparent';
                this.options.parentEl.style.minHeight = '100vh';
            }
            this.options.parentEl.appendChild(this.el);
        }
    }
}
export default UIOverlay;
